import React from 'react';
import c from 'classnames';

import { useHeadlessResults } from '@uncinc/react-searchkit';

import TaxonomyThemeCardChild from '../../../implementations/Taxonomy/Theme/Card/Child';
import type { SearchThemesHit } from '../types';

import './style.scss';

export interface SearchThemesResultsProps {
  title?: string;
  className?: string;
}

const SearchThemesResults: React.FC<SearchThemesResultsProps> = ({ title, className }) => {
  const { infiniteHits } = useHeadlessResults();

  const classes = c('SearchThemes__Results', className);

  if (infiniteHits.length === 0) {
    return null;
  }

  return (
    <div className={classes}>
      {title && (
        <h2 className="SearchThemes__Results__title">{title}</h2>
      )}

      <ul className="SearchThemes__Results__list">
        {(infiniteHits as SearchThemesHit[]).map((hit) => (
          <li key={hit.tid[0]}>
            <TaxonomyThemeCardChild
              url={hit.url[0]}
              title={hit.taxonomy_name[0]}
              image={hit.taxonomy_image_ratio_1_1_xxs?.[0]}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SearchThemesResults;
